import styled from 'styled-components';

export const WizardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 4px;
  }
`;

export const Tab = styled.button<{ isActive: boolean }>`
  padding: 12px 20px;
  border: none;
  background-color: transparent;
  color: ${props => (props.isActive ? '#0a1e3d' : '#999')};
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: ${props => (props.isActive ? '600' : '500')};
  cursor: pointer;
  border-bottom: 3px solid ${props => (props.isActive ? '#ff8c42' : 'transparent')};
  transition: all 0.3s ease;

  &:hover {
    color: #0a1e3d;
  }

  @media (max-width: 768px) {
    padding: 10px 16px;
    font-size: 12px;
  }
`;

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  background: linear-gradient(135deg, #f8f9fa 0%, #f5f7fa 100%);
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    margin-bottom: 16px;
  }
`;

export const StepItem = styled.div<{ isActive: boolean; isCompleted: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: -8px;
    top: 50%;
    width: 16px;
    height: 2px;
    background-color: ${props => (props.isCompleted ? '#4caf50' : '#e0e0e0')};
    transform: translateY(-50%);

    @media (max-width: 768px) {
      display: none;
    }
  }

  @media (max-width: 768px) {
    flex: none;
    width: 100%;

    &:not(:last-child)::after {
      display: none;
    }
  }
`;

export const StepNumber = styled.div<{ isActive: boolean; isCompleted: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: ${props => {
    if (props.isCompleted) return '#4caf50';
    if (props.isActive) return '#ff8c42';
    return '#e8eef5';
  }};
  color: ${props => {
    if (props.isCompleted || props.isActive) return '#fff';
    return '#999';
  }};
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
  box-shadow: ${props => props.isActive ? '0 4px 12px rgba(255, 140, 66, 0.25)' : 'none'};
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }
`;

export const StepLabel = styled.span<{ isActive: boolean }>`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: ${props => (props.isActive ? '600' : '500')};
  color: ${props => (props.isActive ? '#0a1e3d' : '#666')};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const WizardCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 28px;
  background-color: #fff;
  border: 1px solid #e8eef5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 768px) {
    padding: 20px;
    gap: 18px;
  }
`;

export const CardTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`;

export const CardDescription = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const FormFieldFull = styled.div`
  grid-column: 1 / -1;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > div {
    width: 100%;
  }
`;

export const Label = styled.label`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #0a1e3d;
  margin-bottom: 4px;
`;

export const DropZone = styled.div<{ isDragOver: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 32px;
  border: 2px dashed ${props => (props.isDragOver ? '#ff8c42' : '#d4dce8')};
  border-radius: 12px;
  background-color: ${props => (props.isDragOver ? '#fff8f0' : '#f8f9fa')};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff8c42;
    background-color: #fff8f0;
  }

  @media (max-width: 768px) {
    padding: 36px 24px;
  }
`;

export const DropZoneText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #0a1e3d;
  margin: 0;
  text-align: center;
`;

export const DropZoneSubtext = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #999;
  margin: 0;
  text-align: center;
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%);
  border-radius: 8px;
  border-left: 4px solid #4caf50;
  gap: 12px;
`;

export const FileInfoText = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;
  flex: 1;
`;

export const PreviewContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const PreviewCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background-color: #f8f9fa;
  border: 1px solid #e8eef5;
  border-radius: 12px;
`;

export const PreviewImage = styled.img`
  width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #f5f5f5;
`;

export const PreviewPlaceholder = styled.div`
  width: 100%;
  height: 300px;
  background-color: #f5f5f5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
`;

export const EditableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #e8eef5;
  border-radius: 12px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e8eef5;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;

    button {
      width: 100%;
    }
  }
`;

export const SectionName = styled.input`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #0a1e3d;
  border: none;
  background-color: transparent;
  padding: 0;
  border-bottom: 2px solid transparent;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-bottom-color: #ff8c42;
  }

  &:disabled {
    cursor: default;
    border-bottom-color: transparent;
  }
`;

export const DishList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DishItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  background-color: #f8f9fa;
  border: 1px solid #e8eef5;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #fff;
    border-color: #d4dce8;
  }
`;

export const DishInputRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr 100px;
  gap: 12px;
  align-items: flex-start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 10px;

    > div:last-child {
      display: flex;
      gap: 8px;

      button {
        flex: 1;
      }
    }
  }
`;

export const InputSmall = styled.input`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  padding: 10px 12px;
  border: 1px solid #d4dce8;
  border-radius: 6px;
  background-color: #fff;
  transition: all 0.2s ease;

  &::placeholder {
    color: #999;
  }

  &:focus {
    outline: none;
    border-color: #ff8c42;
    box-shadow: 0 0 0 3px rgba(255, 140, 66, 0.1);
  }
`;

export const TextAreaSmall = styled.textarea`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  padding: 10px 12px;
  border: 1px solid #d4dce8;
  border-radius: 6px;
  background-color: #fff;
  resize: vertical;
  min-height: 70px;
  transition: all 0.2s ease;

  &::placeholder {
    color: #999;
  }

  &:focus {
    outline: none;
    border-color: #ff8c42;
    box-shadow: 0 0 0 3px rgba(255, 140, 66, 0.1);
  }
`;

export const DishActions = styled.div`
  display: flex;
  gap: 6px;

  button {
    padding: 4px 8px;
    font-size: 11px;
  }
`;

export const AddButton = styled.button`
  padding: 10px 16px;
  background-color: transparent;
  border: 2px dashed #ff8c42;
  color: #ff8c42;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    background-color: #fff8f0;
    border-style: solid;
    box-shadow: 0 2px 8px rgba(255, 140, 66, 0.15);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const ConfirmSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #f5f7fa 100%);
  border-radius: 12px;
  border: 1px solid #e8eef5;
`;

export const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background-color: #fff;
  border-radius: 8px;
  border-left: 4px solid #ff8c42;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`;

export const SummaryLabel = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #666;
  font-weight: 600;
`;

export const SummaryValue = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 15px;
  color: #0a1e3d;
  font-weight: 700;
  text-align: right;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e8eef5;

  button {
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 10px;

    button {
      width: 100%;
      padding: 12px 16px;
      font-size: 13px;
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px;
  text-align: center;
`;

export const LoadingText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;
  margin: 0;
`;
